const updates = [
  { date: '07-31', title: '《锦绣芳华》第 48 集更新，大结局倒计时', type: '更新' },
  { date: '07-31', title: '《暗夜追击》全 36 集高清完整版上线', type: '全集' },
  { date: '07-30', title: '2026 暑期档特辑：十大必追新剧推荐发布', type: '专题' },
  { date: '07-30', title: '《春风十里不如你》会员提前看第 22 集', type: '更新' },
  { date: '07-29', title: '韩剧专区新增 5 部高分热播剧全集', type: '上新' },
  { date: '07-29', title: '《大漠孤烟》豆瓣开分 9.1，口碑持续走高', type: '资讯' },
  { date: '07-28', title: '《未来之城 2049》特效制作特辑独家发布', type: '花絮' },
  { date: '07-28', title: '悬疑剧场专题页上线，50+ 高分烧脑剧', type: '专题' },
  { date: '07-27', title: '播放器全面升级，4K 画质流畅度提升 40%', type: '公告' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold mb-4">
            <i className="ri-flashlight-line text-sm w-4 h-4 flex items-center justify-center"></i>
            最新动态
          </p>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">平台更新快讯</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">实时了解桔子影视最新剧集上架、更新进度与平台动态。</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, idx) => (
            <div key={idx} className="flex items-start gap-4 py-4 border-b border-background-200/60 last:border-0 group cursor-pointer">
              <span className="flex-shrink-0 text-xs text-foreground-400 font-mono pt-0.5 whitespace-nowrap">{item.date}</span>
              <span className={`flex-shrink-0 px-2 py-0.5 rounded text-[10px] font-semibold whitespace-nowrap ${
                item.type === '更新' ? 'bg-primary-100 text-primary-700' :
                item.type === '全集' ? 'bg-accent-100 text-accent-700' :
                item.type === '上新' ? 'bg-secondary-100 text-secondary-700' :
                'bg-background-200 text-foreground-600'
              }`}>{item.type}</span>
              <span className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors leading-relaxed">{item.title}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}